(function (Drupal) {
  Drupal.behaviors.scrollSpyUpdate = {
    attach(context, settings) {
      const navLinks = document.querySelectorAll('.navbar-nav .nav-link[href^="/#"]');
      const sections = Array.from(navLinks)
        .map(link => document.querySelector(link.getAttribute('href').replace('/', '')))
        .filter(Boolean);

      const offset = 100; // adjust based on navbar height

      const updateActiveLink = () => {
        let currentId = null;

        for (const section of sections) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= offset && rect.bottom > offset) {
            currentId = section.id;
            break;
          }
        }

        navLinks.forEach(link => {
          const href = link.getAttribute('href');
          const matches = href === `/#${currentId}`;
          link.classList.toggle('active', matches);
          link.parentElement.classList.toggle('active', matches); // if needed for li
        });

        if (currentId && location.hash !== `#${currentId}`) {
          history.replaceState(null, '', `/#${currentId}`);
        }
      };

      window.addEventListener('scroll', updateActiveLink, { passive: true });
      window.addEventListener('resize', updateActiveLink);
      updateActiveLink(); // initial run
    }
  };
})(Drupal);
